// HbxUploadExampleInvoices.styles.js
export default {
  container: {
    backgroundColor: 'white',
    padding: '40px 20px',
    borderRadius: 10,
    display: 'flex',
    flexWrap: 'wrap',
    gap: '20px',
    justifyContent: 'center',
    alignItems: 'flex-start',
    width: '90%',
    maxWidth: '1200px',
    margin: '40px auto',
  },
  buttonWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 16,
    flex: '1 1 250px',
  },
  buttonTitle: {
    display: 'flex',
    alignItems: 'center',
    fontSize: '1.1rem',
    fontWeight: 700,
    marginBottom: 8,
    gap: 8,
    textAlign: 'center',
    color: 'black',
  },
  buttonTitleIcon: {
    fontSize: 20,
  },
  buttonBox: {
    backgroundColor: '#57B9FF',
    color: 'white',
    borderRadius: 10,
    width: '100%',
    maxWidth: 450,
    minHeight: 100,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 12,
    cursor: 'pointer',
    transition: 'all 0.2s',
    padding: '0 20px',
    fontWeight: 700,
  },
  buttonIcon: {
    fontSize: 28,
  },
  buttonText: {
    fontSize: 14,
    fontWeight: 500,
    textAlign: 'left',
  },
};
